import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'
import { RestServices } from '../../services/rest.services'
import { FormBuilder, FormGroup } from '@angular/forms'
import { emailValidator, validateAllFormFields } from '../../../models/customValidators'

@Component({
    selector: 'app-application',
    templateUrl: './application.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class ApplicationComponent implements OnInit {
    en = {}
    showEN = true
    apply = false
    appFormGroup: FormGroup
    str: string
    statusEmail: string

    constructor(private auth: AuthService, private formBuider: FormBuilder, private checkFormat: RestServices) {
        this.validatorForm()
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    validatorForm() {
        this.appFormGroup = this.formBuider.group({
            email: ['', [emailValidator()]],
        })
    }

    checkFormatEmail() {
        const format = this.appFormGroup.value.email.slice(this.appFormGroup.value.email.search('@') + 1)
        this.checkFormat.http_post('form/checkMx', { host: format }).subscribe(
            response => {
                this.str = response['status']
            },
        )
    }

    // message valid
    isFieldValid(field: string) {
        return !this.appFormGroup.get(field).valid && this.appFormGroup.get(field).touched || this.appFormGroup.get(field).dirty && (this.appFormGroup.get(field).status === 'INVALID')
    }

    // message css
    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
        }
    }

    onSubmit() {
        if (this.appFormGroup.valid) {
            this.apply = true
        } else {
            validateAllFormFields(this.appFormGroup)
        }
    }

    // submit apply
    submitApply() {
        const lang = localStorage.getItem('lang') === 'true' ? 'en' : 'ja'
        const body = {
            data: { type: 'new-registration', email: this.appFormGroup.value.email },
            type: 'registration',
            lang: lang,
        }
        this.checkFormat.http_post('form', body).subscribe(
            success => {
                this.statusEmail = success['status']
            },
        )
    }

    // back form
    reset() {
        this.apply = false
        this.statusEmail = 'no'
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/application/application.component.ts